import useFlatObjectKeys from './useFlatObjectKeys'

const usePanelRibbonErrors = (errors) => {
  const errorKeys = useFlatObjectKeys(errors)

  return errorKeys
}

export default usePanelRibbonErrors
